import {Injectable, EventEmitter, OnInit} from "@angular/core";
import {Message} from "../models/message";
import {Observable} from "rxjs";

@Injectable()
export class MessageService{
    messages: Message[] = [];

    showMessage = new EventEmitter<Message>();
    hideMessage = new EventEmitter<Message>();

    timer: any;

    constructor(){
        this.timer = Observable.timer(1000,1000);
        this.timer.subscribe(this.actualize.bind(this));
    }

    actualize(){
        this.messages.forEach(msg => {
            msg.show_seconds -= 1;

            if(msg.show_seconds == -1){
                this.hide(msg);
            }
        })
    }

    show(message: Message){
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].title === message.title) {
                return;
            }
        }

        this.messages.push(message);

        this.showMessage.emit(message);
    }

    hide(message: Message){
        this.messages = this.messages.filter(el  => el.title !== message.title);

        this.hideMessage.emit(message);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/message.service.ts